export default class Mip implements MipInterface {

	public min: number;
	public max: number;
	public percentage: number;

	constructor(object: MipInterface) {
		this.min = object.min;
		this.max = object.max;
		this.percentage = object.percentage;
	}

	public getMinMonth(): number {
		return this.min <= 18 ? this.min * 12 : this.min * 12 - 11;
	}

	public getMaxMonth(): number {
		return this.max * 12;
	}
}

interface MipInterface {
	min: number;
	max: number;
	percentage: number;
}



// WEBPACK FOOTER //
// ./src/base/Mip.ts